// extracted by mini-css-extract-plugin
export default {"container":"jF-z","disabled":"kF-z","bgBlack":"lF-z","content":"mF-z","countdown":"nF-z","topCaption":"oF-z","topHeading":"pF-z","heading":"qF-z","copy":"rF-z"};